import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { FaqService } from '../../services/faq.service';
import { IFaqDto } from '../../interfaces/Faq/ifaq-dto';

@Component({
  selector: 'app-influenza-outbreak-information',
  templateUrl: './influenza-outbreak-information.component.html',
  styleUrls: ['./influenza-outbreak-information.component.css']
})
export class InfluenzaOutbreakInformationComponent implements OnInit {

  faq: IFaqDto;
  loading = false;

  constructor(private sharedService: SharedService, private faqService: FaqService) { }

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.loadFaq();
  }

  loadFaq() {
    this.loading = true;
    this.faqService.getFaqByCode('influenza-outbreak-information').subscribe(result => {
      this.faq = result;
      this.loading = false;
      this.sharedService.showLoadingMessage = false;
    }, error => {
      console.error(error);
      this.loading = false;
      this.sharedService.showLoadingMessage = false;
    });
  }

}
